/**
 * Copyright (c) Streamlit Inc. (2018-2022) Snowflake Inc. (2022-2026)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export const DEPLOY_URL = "https://share.streamlit.io/deploy"
export const STREAMLIT_CLOUD_URL = "https://streamlit.io/cloud"

export const STREAMLIT_COMMUNITY_CLOUD_DOCS_URL =
  "https://share.streamlit.io/cloud-getting-started"
export const STREAMLIT_DEPLOY_TUTORIAL_URL =
  "https://share.streamlit.io/deployment-tutorial"

export const SNOWFLAKE_LEARN_MORE_URL = "https://share.streamlit.io/sis-about"

export const SNOWFLAKE_TRIAL_URL = "https://share.streamlit.io/snowflake-trial"
